"use client"

import { useRef } from "react"
import {
    AnimatePresence,
    motion,
    useInView,
} from "motion/react"
import { Box } from '@mui/material';

export function BlurFade({
    children,
    className,
    variant,
    duration = 0.4,
    delay = 0,
    offset = 6,
    direction = "down",
    inView = false,
    inViewMargin = "-50px",
    blur = "6px",
    style,
    sx,
    ...props
}) {
    const ref = useRef(null)
    const inViewResult = useInView(ref, { once: true, margin: inViewMargin })
    const isInView = !inView || inViewResult
    const defaultVariants = {
        hidden: {
            [direction === "left" || direction === "right" ? "x" : "y"]:
                direction === "right" || direction === "down" ? -offset : offset,
            opacity: 0,
            filter: `blur(${blur})`,
        },
        visible: {
            [direction === "left" || direction === "right" ? "x" : "y"]: 0,
            opacity: 1,
            filter: `blur(0px)`,
        },
    }
    const combinedVariants = variant || defaultVariants
    return (
        <AnimatePresence>
            <Box
                component={motion.div}
                ref={ref}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                exit="hidden"
                variants={combinedVariants}
                transition={{
                    delay: 0.04 + delay,
                    duration,
                    ease: "easeOut",
                }}
                sx={{ ...sx }}
                style={style}
                className={className}
                {...props}
            >
                {children}
            </Box>
        </AnimatePresence>
    )
}
